define('views/filter-header',["exports", "backbone", "bootstrap/dropdown", "rivets"], function (_exports, _backbone, _dropdown, _rivets) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _rivets = _interopRequireDefault(_rivets);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .filter-reset__btn'() {
        this.trigger('reset-filter');
      },
      'click .filter-view__btn'() {
        this.trigger('toggle-map');
      },
      'click .filter-filters .filter__btn'() {
        this.trigger('show-modal');
      },
      'click .filter-sort .dropmenu__btn'({
        target
      }) {
        this.listState.set({
          sort: target.value
        });
      }
    },
    initialize(options) {
      var listState = this.listState = options.listState;
      this.btnMap = this.el.querySelector('.filter-view__btn');
      this.binding = _rivets.default.bind(this.el, {
        f: listState
      });
    },
    toggleMap(flag) {
      this.btnMap.classList.toggle('filter__btn--active', flag);
    }
  });
});//# sourceMappingURL=filter-header.js.map
;
